<template>
    <div class="title-container flex align-center justify-between">
        <div class="title text-xl text-black text-bold margin-left-sm">{{ title }}</div>
        <div class="operate flex align-center">
            <el-button v-if="cancel" class="cancel radius margin-right-sm" type="primary" @click="$router.go(-1)">返回</el-button>
<!--            <div class="flex align-center">-->
<!--                <div class="name">{{user.name}}</div>-->
<!--                <div class="name">{{user.mrole | role}}</div>-->
<!--            </div>-->
            <el-dropdown trigger="click" @command="command">
                  <span class="el-dropdown-link">
                     <el-avatar class="bg-blue cursor" :size="50">{{user.name | avatar}} </el-avatar>
                  </span>
                <el-dropdown-menu  class="logout"  slot="dropdown">
                    <el-dropdown-item disabled>{{user.name}}</el-dropdown-item>
                    <el-divider></el-divider>
                    <el-dropdown-item disabled>{{user.mrole | role}}</el-dropdown-item>
<!--                    <el-divider></el-divider>-->
<!--                    <el-dropdown-item command="home">首页</el-dropdown-item>-->
<!--                    <el-dropdown-item command="logout">退出</el-dropdown-item>-->
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>

import {getAvatarName, userLogout} from "@/utils/utils";
import {role_name} from "@/utils/const";

export default {
    components: {},
    name: "PageTitleModular",
    data() {
        return {}
    },
    props: {
        title: {
            type: String,
            default: '全部项目'
        },
        cancel: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {

    },
    methods: {
        command(e) {
            switch (e) {
                case 'logout' :
                    userLogout()
                    break
                case 'home' :
                    this.$router.push('/web/home')
                    break
            }
        }
    } ,
    filters:{
        role(val){
            return role_name(val)
        },
        avatar(name){
            return getAvatarName(name)
        }
    }
}
</script>

<style lang="scss" scoped>
.title-container {
    width: 100%;
    height: 60px;

    .operate {
        .cancel {
            width: 99px;
            height: 40px;
        }

    }
}
</style>